type Props = {
  eyebrow?: string;
  title: string;
  description: string;
};

const SeoIntro = ({ eyebrow, title, description }: Props) => (
  <section className='border-t-2 bg-white'>
    <div className='mx-auto max-w-[1240px] w-full px-6 py-6 xs:px-4 xs:py-5'>
      {eyebrow && (
        <p className='mb-2 text-xxs leading-xxs font-bold uppercase text-main-grey-800'>
          {eyebrow}
        </p>
      )}
      <h1 className='max-w-[760px] text-3xl leading-3xl font-bold text-black md:text-2xl md:leading-2xl'>
        {title}
      </h1>
      <p className='mt-3 max-w-[760px] text-sm leading-sm text-main-grey-800'>
        {description}
      </p>
    </div>
  </section>
);

export { SeoIntro };
